var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v(" Change the listing sequence of documents in \""+_vm._s(_vm.collectionName)+"\" by dragging their ids in this list (documents below will sort accordingly): ")])}
var staticRenderFns = []

export { render, staticRenderFns }